import { useMutation } from '@tanstack/react-query';
import { uploadFileToPresignedURL } from '../../../../shared/service/selfService';
import { MutationCallbacks } from '../../../../shared/types/mutation';

type UploadToPresignedURLParams = {
  file: File;
  presignedUrl: string;
};

// The file upload goes to S3 via a presigned URL. The backend detects the
// upload asynchronously (e.g., via an S3 event trigger) and creates the
// ingestion record in the database. There is a brief sync delay between the
// S3 upload completing and the record being available via the files list API.
// We wait 1 second after a successful upload to give the backend time to
// process the S3 event before the caller invalidates the cache and refetches.
const POST_UPLOAD_SYNC_DELAY_MS = 2000;

export default function useUploadToPresignedURL({
  onSuccess,
  onError,
}: MutationCallbacks) {
  return useMutation<void, unknown, UploadToPresignedURLParams>({
    mutationFn: async ({ file, presignedUrl }) => {
      await uploadFileToPresignedURL(presignedUrl, file);
      await new Promise((resolve) =>
        setTimeout(resolve, POST_UPLOAD_SYNC_DELAY_MS),
      );
    },
    onSuccess,
    onError,
  });
}
